<template>
    <div class="liu-yue-liu-ri-container">
        <!-- 流月表格 -->
        <div class="table-section">
            <h3 style="color: #ffa500; margin-bottom: 16px;">流月</h3>
            <a-table :dataSource="liuYueData" :columns="liuYueColumns" :pagination="false" size="small" bordered
                class="custom-table">
                <template #bodyCell="{ column, record }">
                    <template v-if="column.key === 'date'">
                        <span>{{ record.date }}</span>
                    </template>
                    <template v-if="column.key === 'gan_zhi'">
                        <span class="gan-zhi-cell">{{ record.gan_zhi }}</span>
                    </template>
                    <template v-if="column.key === 'name'">
                        <span>{{ record.name }}</span>
                    </template>
                    <template v-if="column.key === 'shi_shen_comb'">
                        <span>{{ record.shi_shen_comb }}</span>
                    </template>
                </template>
            </a-table>
        </div>

        <!-- 流日表格 -->
        <div class="table-section">
            <h3 style="color: #ffa500; margin-bottom: 16px;">流日</h3>
            <a-table :dataSource="liuRiData" :columns="liuRiColumns" :pagination="false" size="small" bordered
                class="custom-table">
                <template #bodyCell="{ column, record }">
                    <template v-if="column.key === 'date'">
                        <span>{{ record.date }}</span>
                    </template>
                    <template v-if="column.key === 'gan_zhi'">
                        <span class="gan-zhi-cell">{{ record.gan_zhi }}</span>
                    </template>
                    <template v-if="column.key === 'shi_shen'">
                        <span :class="getShiShenClass(record.shi_shen)">{{ record.shi_shen }}</span>
                    </template>
                    <template v-if="column.key === 'shi_shen_comb'">
                        <span>{{ record.shi_shen_comb }}</span>
                    </template>
                </template>
            </a-table>
        </div>
    </div>
</template>

<script>
export default {
    name: 'LiuYueLiuRi',
    props: {
        liuYueData: {
            type: Array,
            default: () => []
        },
        liuRiData: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            // 流月表格列配置
            liuYueColumns: [
                {
                    title: '月份',
                    dataIndex: 'date',
                    key: 'date',
                    width: '25%',
                    align: 'center'
                },
                {
                    title: '干支',
                    dataIndex: 'gan_zhi',
                    key: 'gan_zhi',
                    width: '25%',
                    align: 'center'
                },
                {
                    title: '节气',
                    dataIndex: 'name',
                    key: 'name',
                    width: '25%',
                    align: 'center'
                },
                {
                    title: '十神组合',
                    dataIndex: 'shi_shen_comb',
                    key: 'shi_shen_comb',
                    width: '25%',
                    align: 'center'
                }
            ],
            // 流日表格列配置
            liuRiColumns: [
                {
                    title: '日期',
                    dataIndex: 'date',
                    key: 'date',
                    width: '25%',
                    align: 'center'
                },
                {
                    title: '干支',
                    dataIndex: 'gan_zhi',
                    key: 'gan_zhi',
                    width: '25%',
                    align: 'center'
                },
                {
                    title: '十神',
                    dataIndex: 'shi_shen',
                    key: 'shi_shen',
                    width: '25%',
                    align: 'center'
                },
                {
                    title: '十神组合',
                    dataIndex: 'shi_shen_comb',
                    key: 'shi_shen_comb',
                    width: '25%',
                    align: 'center'
                }
            ]
        };
    },
    methods: {
        // 十神样式类
        getShiShenClass(ss) {
            if (!ss) return ''
            if (ss.includes('财')) return 'ss-cai'
            if (ss.includes('官') || ss.includes('杀')) return 'ss-guan'
            if (ss.includes('印')) return 'ss-yin'
            if (ss.includes('比') || ss.includes('劫')) return 'ss-bi'
            if (ss.includes('食') || ss.includes('伤')) return 'ss-shi'
            return ''
        }
    }
};
</script>

<style scoped>
.liu-yue-liu-ri-container {
    margin-top: 20px;
    padding: 16px;
    background: #1e1e2f;
    border-radius: 8px;
}

.table-section {
    margin-bottom: 24px;
}

.table-section:last-child {
    margin-bottom: 0;
}

:deep(.custom-table .ant-table) {
    background: transparent;
    color: #fff;
}

:deep(.custom-table .ant-table-thead > tr > th) {
    background: #2a2a3c !important;
    color: #ffa500 !important;
    border-color: #444 !important;
    font-weight: bold;
    text-align: center;
}

:deep(.custom-table .ant-table-tbody > tr > td) {
    background: #1e1e2f !important;
    color: #fff !important;
    border-color: #444 !important;
    text-align: center;
}

:deep(.custom-table .ant-table-tbody > tr:hover > td) {
    background: #2a2a3c !important;
}

.gan-zhi-cell {
    font-weight: bold;
    color: #40a9ff;
}

/* 十神颜色样式 */
.ss-cai {
    color: #ff4d4f;
    font-weight: bold;
}

.ss-guan {
    color: #40a9ff;
    font-weight: bold;
}

.ss-yin {
    color: #73d13d;
    font-weight: bold;
}

.ss-bi {
    color: #ffa940;
    font-weight: bold;
}

.ss-shi {
    color: #9254de;
    font-weight: bold;
}
</style>